import React from 'react'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { Link } from 'react-router-dom'

interface DataMenuProps {
  label: string
}
const DataMenu = (props: DataMenuProps) => {
  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret className='glyphicons glyphicons-database-search'>
      <p className='nav-link-p'>{props.label}</p>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem>
          <a href='/ui/#!/data' className='glyphicons glyphicons-database-search'>
            All Collections
          </a>
        </DropdownItem>
        <DropdownItem>
          <Link to='/ui2/data/groups' className='glyphicons glyphicons-database-search'>
            Only Groups
          </Link>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
export default DataMenu